import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const TRANSLATIONS_UPDATE_IMPORT_ERRORS = {
  // Supplier product
  '200-supplier-product-not-found': 'INVALID_SUPPLIER_PRODUCT_NOT_FOUND',
  '200-supplier-product-not-active': 'INVALID_SUPPLIER_PRODUCT_NOT_ACTIVE',
  '200-supplier-product-invalid-language-code': 'INVALID_SUPPLIER_PRODUCT_LANGUAGE_CODE',
  '200-supplier-product-packaging-not-active': 'INVALID_SUPPLIER_PRODUCT_PACKAGING_NOT_ACTIVE',

  // Ingredient
  '200-ingredient-not-found': 'INVALID_INGREDIENT_NOT_FOUND',
  '200-ingredient-not-active': 'INVALID_INGREDIENT_NOT_ACTIVE',
  '200-ingredient-invalid-language-code': 'INVALID_INGREDIENT_LANGUAGE_CODE',

  // Recipe
  '200-recipe-not-found': 'INVALID_RECIPE_NOT_FOUND',
  '200-recipe-not-active': 'INVALID_RECIPE_NOT_ACTIVE',
  '200-recipe-invalid-language-code': 'INVALID_RECIPE_LANGUAGE_CODE',

  // Product
  '200-product-not-found': 'INVALID_PRODUCT_NOT_FOUND',
  '200-product-not-active': 'INVALID_PRODUCT_NOT_ACTIVE',
  '200-product-invalid-language-code': 'INVALID_PRODUCT_LANGUAGE_CODE',

  // Category
  '200-category-not-found': 'INVALID_CATEGORY_NOT_FOUND',
  '200-category-invalid-language-code': 'INVALID_CATEGORY_LANGUAGE_CODE',

  // Sub category
  '200-sub-category-not-found': 'INVALID_SUB_CATEGORY_NOT_FOUND',
  '200-sub-category-invalid-language-code': 'INVALID_SUB_CATEGORY_LANGUAGE_CODE',
};

const getSheetLanguageCodesError = (error) => [
  {
    error: i18next.t(
      `_BACKEND_TRANSLATIONS.TRANSLATIONS.ERROR_FILE_${TRANSLATIONS_UPDATE_IMPORT_ERRORS[error]}`,
    ),
  },
];

const formatUnValidatedDataForExport = (unvalidatedData) => {
  if (!unvalidatedData) {
    return [];
  }

  return unvalidatedData.map((item) => ({
    ...item,
    error: i18next.t(
      `_BACKEND_TRANSLATIONS.TRANSLATIONS.ERROR_FILE_${
        TRANSLATIONS_UPDATE_IMPORT_ERRORS[item.error]
      }`,
    ),
  }));
};

const getGenericColumns = () => [
  { propertyKey: 'name', name: i18next.t('GENERAL.NAME') },
  {
    propertyKey: 'error',
    name: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.LIST_COLUMN_ERROR'),
  },
];

const getCategoryAndSubCategoryColumns = () => [
  { propertyKey: 'name', name: i18next.t('GENERAL.NAME') },
  { propertyKey: 'type', name: i18next.t('GENERAL.TYPE') },
  {
    propertyKey: 'error',
    name: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.LIST_COLUMN_ERROR'),
  },
];

export const getImportErrorFileConfig = (
  unValidatedSupplierProducts,
  unValidatedIngredients,
  unValidatedRecipes,
  unValidatedProducts,
  unValidatedCategories,
  unValidatedSubCategories,
  unValidatedSupplierProductsSheetLanguageColumns,
  unValidatedIngredientsSheetLanguageColumns,
  unValidatedRecipesSheetLanguageColumns,
  unValidatedProductsSheetLanguageColumns,
  unValidatedCategoriesSheetLanguageColumns,
  unValidatedSubCategoriesSheetLanguageColumn,
) => {
  const formattedUnValidatedSupplierProducts = !!unValidatedSupplierProductsSheetLanguageColumns
    ? getSheetLanguageCodesError(unValidatedSupplierProductsSheetLanguageColumns?.error)
    : formatUnValidatedDataForExport(unValidatedSupplierProducts);

  const formattedUnValidatedIngredients = !!unValidatedIngredientsSheetLanguageColumns
    ? getSheetLanguageCodesError(unValidatedIngredientsSheetLanguageColumns?.error)
    : formatUnValidatedDataForExport(unValidatedIngredients);

  const formattedUnValidatedRecipes = !!unValidatedRecipesSheetLanguageColumns
    ? getSheetLanguageCodesError(unValidatedRecipesSheetLanguageColumns?.error)
    : formatUnValidatedDataForExport(unValidatedRecipes);

  const formattedUnValidatedProducts = !!unValidatedProductsSheetLanguageColumns
    ? getSheetLanguageCodesError(unValidatedProductsSheetLanguageColumns?.error)
    : formatUnValidatedDataForExport(unValidatedProducts);

  const formattedUnValidatedCategories = !!unValidatedCategoriesSheetLanguageColumns
    ? getSheetLanguageCodesError(unValidatedCategoriesSheetLanguageColumns?.error)
    : formatUnValidatedDataForExport(unValidatedCategories);

  const formattedUnValidatedSubCategories = !!unValidatedSubCategoriesSheetLanguageColumn
    ? getSheetLanguageCodesError(unValidatedSubCategoriesSheetLanguageColumn?.error)
    : formatUnValidatedDataForExport(unValidatedSubCategories);

  const supplierProductSheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.SUPPLIER_PRODUCTS_SHEET_NAME'),
    getGenericColumns(),
    formattedUnValidatedSupplierProducts,
  );

  const ingredientSheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.INGREDIENTS_SHEET_NAME'),
    getGenericColumns(),
    formattedUnValidatedIngredients,
  );

  const recipeSheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.RECIPES_SHEET_NAME'),
    getGenericColumns(),
    formattedUnValidatedRecipes,
  );

  const productSheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.PRODUCTS_SHEET_NAME'),
    getGenericColumns(),
    formattedUnValidatedProducts,
  );

  const categorySheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.CATEGORIES_SHEET_NAME'),
    getCategoryAndSubCategoryColumns(),
    formattedUnValidatedCategories,
  );

  const subCategorySheet = utilsXLS.generateDefaultSheet(
    i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.SUB_CATEGORIES_SHEET_NAME'),
    getCategoryAndSubCategoryColumns(),
    formattedUnValidatedSubCategories,
  );

  utilsXLS.makeXLS(i18next.t('_BACKEND_TRANSLATIONS.TRANSLATIONS.IMPORT_ERROR_FILE_TITLE'), [
    supplierProductSheet,
    ingredientSheet,
    recipeSheet,
    productSheet,
    categorySheet,
    subCategorySheet,
  ]);
};
